import { render } from "./OrderHistoryEntryProducts.vue?vue&type=template&id=09270efa"
import script from "./OrderHistoryEntryProducts.vue?vue&type=script&lang=js"
export * from "./OrderHistoryEntryProducts.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__